import { Stack, Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { generateGtmEvent } from "../Helpers";
import { v2theme } from "../styles/Theme";
import { Question } from "./utils/CourseTree";
import { MockProblemContainer } from "./v2/mocktour/MockProblemContainer";
import { ButtonZoom } from "./v2/utils/ButtonZoom";

const useStyles = makeStyles((theme) => ({
  button: {
    width: 276,
    height: 185,
    fontSize: "1.75em",
    display: "flex",
    flexDirection: "column",
  },
  faIcon: {
    marginTop: "16px",
    height: "36px",
  },
  selectorContent: {
    minHeight: "440px",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

interface GPPLearningPreferenceProps {
  currentQuestion: Question;
  handleSelectGPPPreference: (preferText: boolean) => void;
}

export const GPPLearningPreference = ({
  handleSelectGPPPreference,
  currentQuestion,
}: GPPLearningPreferenceProps) => {
  const classes = useStyles();

  return (
    <MockProblemContainer currentQuestion={currentQuestion}>
      <Box className={classes.selectorContent}>
        <Typography variant="h1" sx={{ textAlign: "center", marginBottom: "24px" }}>
          Welcome to Guided Practice!
        </Typography>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", fontWeight: "bold" }}
          color={v2theme.palette.text.secondary}>
          Choose your learning preference:
        </Typography>
        <Stack
          direction="row"
          spacing="30px"
          justifyContent="center"
          sx={{ marginTop: "32px", marginBottom: "64px" }}>
          <ButtonZoom
            variant="outlined"
            className={classes.button}
            iconPosition="left"
            icon={<i className={`fa-regular fa-circle-play fa-lg ${classes.faIcon}`}></i>}
            iconHover={
              <i className={`fa-solid fa-circle-play fa-lg ${classes.faIcon}`}></i>
            }
            onClick={() => {
              generateGtmEvent({
                event: "link",
                action: "click",
                name: "onclick",
                type: "internal link",
                region: "main content",
                section: "welcome to guided practice!",
                text: "video",
                component: currentQuestion.name,
              });
              handleSelectGPPPreference(false);
            }}>
            Video
          </ButtonZoom>
          <ButtonZoom
            variant="outlined"
            className={classes.button}
            iconPosition="left"
            icon={<i className={`fa-regular fa-book fa-lg ${classes.faIcon}`}></i>}
            iconHover={<i className={`fa-solid fa-book fa-lg ${classes.faIcon}`}></i>}
            onClick={() => {
              generateGtmEvent({
                event: "link",
                action: "click",
                name: "onclick",
                type: "internal link",
                region: "main content",
                section: "welcome to guided practice!",
                text: "text",
                component: currentQuestion.name,
              });
              handleSelectGPPPreference(true);
            }}>
            Text
          </ButtonZoom>
        </Stack>
      </Box>
    </MockProblemContainer>
  );
};
